// Toggle the menu open and close when on mobile
export default function stickyHeader() {
    // Get the header element
    const header = document.getElementById("gh-head");

    // Function to add the "header-is-sticky" class when scroll offset > 0
    function makeHeaderSticky() {
        if (window.pageYOffset > 0) {
            header.classList.add("header-is-sticky");
        } else {
            header.classList.remove("header-is-sticky");
        }
    }

    window.addEventListener("scroll", makeHeaderSticky);
    window.addEventListener("load", makeHeaderSticky);
}
